cb.define(function() {
    var AA_sys_bizloglist_VM_Extend = {
        init: function (viewmodel) {
            var self = this;
            viewmodel.on('beforeEdit', function(data) {
                viewmodel.communication({
                    type: 'modal',
                    payload: {
                      key: 'TextDiff',
                      data: {
                        model: viewmodel,
                        id: data.carry.id
                      },
                    },
                  });
                  return false;
            })
        },
        doAction: function (name, viewmodel) {
            if (this[name]) {
              this[name](viewmodel);
            }
        },
    }
    try {
      module.exports = AA_sys_bizloglist_VM_Extend;
    } catch (error) {
  
    }
    return AA_sys_bizloglist_VM_Extend;
  });



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_sys_bizloglist_VM.Extend.js